import Axios from "axios";
import Offer from "@/models/Offer";
import UploadInfo from "@/models/UploadInfo";
import OfferContent from "@/models/OfferContent";

export default abstract class OffersAPI {
  private static axios = Axios.create({
    baseURL: process.env.VUE_APP_API_ROOT
  });

  static async getOffer(offerId: string, requestId: string): Promise<Offer> {
    const url = `/offers?offerId=${offerId}&requestId=${requestId}&code=${process.env.VUE_APP_API_OFFER_CODE}`;
    const response = await this.axios.get(url);
    return new Offer(response.data);
  }

  static async getUploadInfo(
    requestId: string,
    fileName: string
  ): Promise<UploadInfo> {
    const url = `/attachments/upload?requestId=${requestId}&fileName=${fileName}&code=${process.env.VUE_APP_API_UPLOAD_CODE}`;
    const response = await this.axios.get(url);
    return new UploadInfo(response.data);
  }

  static async uploadAttachment(
    uploadUrl: string,
    file: File,
    onUploadProgress?: (progressEvent: any) => void
  ): Promise<void> {
    const config = {
      headers: { "x-ms-blob-type": "BlockBlob", "Content-Type": file.type },
      onUploadProgress: onUploadProgress
    };
    await this.axios.put(uploadUrl, file, config);
  }

  static async postSubmission(
    offerId: string,
    requestId: string,
    offerContent: OfferContent
  ): Promise<void> {
    const url = `/submissions?code=${process.env.VUE_APP_API_SUBMIT_CODE}`;
    const data = {
      offerId: offerId,
      requestId: requestId,
      offerContent: offerContent
    };
    await this.axios.post(url, data);
  }

  static sleep(ms: number) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }
}
